module.exports = __webpack_public_path__ + "static/media/wizualizacja-85.ffde7380.png";